import { ClickToCallComponent } from './layout/components/clickToCall/clickToCall.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
import { HttpServiceService } from './shared/services/http-service.service';
import { ConstantsService } from './shared/services/constants.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import {ToastrModule} from 'ngx-toastr';
import { Ng2OrderModule } from 'ng2-order-pipe';
import {NgxPaginationModule} from 'ngx-pagination';
import { CommonService } from './shared/services/common.service';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { AmazingTimePickerModule } from 'amazing-time-picker';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { LoginComponent } from './login/login.component';
import { ExcelService } from './shared/services/excel.service';
import {ViewBillComponent} from './layout/components/popups/view-bill/view-bill.component';
import { IframePopup } from './layout/components/popups/IframePopup';
import { ViewDischargeBillComponent } from './layout/components/popups/viewDischargeSummary/view-discharge-summary.component';
import { HospitalChangeComponent } from './layout/components/popups/agreements-view/agreement-view.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { ForFinalBillService } from './shared/services/for-final-bill.service';




@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 1500,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true
        }),
        HttpClientModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        MatDatepickerModule,
        Ng2SearchPipeModule,
        Ng2OrderModule,
        NgxPaginationModule,
        AngularMultiSelectModule,
        NgSelectModule,
        AmazingTimePickerModule,
        MatProgressBarModule,
        ConfirmationPopoverModule.forRoot({
            confirmButtonType: 'danger' 
        })
    ],
    declarations: [AppComponent, LoginComponent, ClickToCallComponent, ViewBillComponent, ViewDischargeBillComponent ,IframePopup, HospitalChangeComponent],
    providers: [AuthGuard, HttpServiceService,
        ConstantsService, CommonService, ExcelService,ForFinalBillService],
    bootstrap: [AppComponent],
    entryComponents: [ClickToCallComponent, ViewBillComponent, ViewDischargeBillComponent, HospitalChangeComponent, IframePopup],
    exports: [MatProgressBarModule]
})
export class AppModule {}
